const styles = theme => ({
    root: {
        backgroundColor: 'white',
        height: '100vh'
    },
    inner: {
        margin: [[30, 25, 25]],
        color: theme.palette.text.primary
    },
    text: {
        color: 'red'
    },
    logo: {
        margin: [[30, 25, 25]]
    },
    header: {
        backgroundColor: 'white',
        margin: [[5, 10, 5]],
        padding: 0,
        borderBottom: '4px #007193 solid'
    }
});

export default styles;
